export * from './TituloServiceAdapter'